import ArrowLeft from 'svg/ArrowLeft';
import Button from 'components/Button';

interface Props {
  title: string;
  onBack: () => void;
}

/** The back arrow and title every booking step opens with. */
export default function StepHeader({ title, onBack }: Props) {
  return (
    <div className="flex items-center gap-ds-lg p-ds-xl">
      <Button
        variant="secondary"
        size="icon"
        isInline
        onClick={onBack}
        aria-label="Back"
        className="size-5 border-none bg-transparent text-color-text-brand lg:w-5"
        iconLeft={<ArrowLeft className="h-5 w-5" />}
      />
      <p className="typography-product-heading-compact text-color-text-brand">{title}</p>
    </div>
  );
}
